import $ from 'jquery';

const pageSelector = '.profile-page';
const linkSelector = '.submenu__link';
const contentSelector = '.profile-page__content';
const activeLinkClass = 'submenu__link_selected';
const activeContentClass = 'profile-page__content_visible';

export default class ProfilePage {
	init() {
		if ($(pageSelector)[0]) {
			$(linkSelector).on('click', e => {
				const $this = $(e.currentTarget);

				const index = $this.attr('id').substr(15);

				// switch active menu link
				$(linkSelector).removeClass(activeLinkClass);
				$this.addClass(activeLinkClass);

				// switch active content part
				$(contentSelector).removeClass(activeContentClass);
				$(`${contentSelector}[data-index='${index}']`).addClass(activeContentClass);
			});
		}
	}
}



// WEBPACK FOOTER //
// ./app/blocks/profile-page/index.js